import { useT } from "@/app/translations/useT";
import { ConceptFlowArrival, ConceptFlowOutput } from "@/app/types/home/ConceptFlow";
import { outputSequenceStyle } from "../ConceptFlow.logic";
import styles from "../ConceptFlow.module.css";
import ConceptFlowAvatarStack from "./ConceptFlowAvatarStack";

type Props = {
  output: ConceptFlowOutput;
  arrivals: ConceptFlowArrival[];
  outputIndex: number;
};

export default function ConceptFlowOutputCard(props: Props) {
  const { output, arrivals, outputIndex } = props;
  const T = useT();

  return (
    <li className={`${styles.card} ${styles.output}`}>
      <div className={styles.outputHead}>
        <span className={styles.outputIcon} aria-hidden="true">
          <output.Icon />
          {arrivals.map((arrival) => (
            <span className={styles.outputPulse} style={arrival.style} key={arrival.id} />
          ))}
        </span>
        <h4 className={styles.outputTitle}>{T(output.titleKey)}</h4>
        {output.syncKey && output.syncLogos && (
          <span className={styles.syncLogos} role="img" aria-label={T(output.syncKey)}>
            {output.syncLogos.map((logo, index) => (
              <span
                className={`${styles.syncLogo} ${logo.toneClass ? styles[logo.toneClass] : ""}`}
                style={outputSequenceStyle(outputIndex, index)}
                key={logo.id}
              >
                <logo.Icon />
              </span>
            ))}
          </span>
        )}
        {output.avatarStack && (
          <ConceptFlowAvatarStack stack={output.avatarStack} outputIndex={outputIndex} />
        )}
      </div>
      <p className={styles.outputNote}>{T(output.noteKey)}</p>
    </li>
  );
}
